module.exports = __webpack_public_path__ + "static/img/banner03.e0bfae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_index/banner03.jpg
// module id = xmvq
// module chunks = 1